import { Box, Flex, Grid, Group, Stack, Text } from '@mantine/core';
import { ReactNode } from '@tabler/icons-react';
import { MessageTemplate } from './model';
import { MessageCategoryText, MessageSendingTargetText } from './components/ui';
import { format } from 'date-fns';
import { ActionSettingDisplay } from './MessageEditor/actionEditor/ActionEditor';
import { TemplatePreview } from './MessageEditor';
import { toMessageFormValue } from './model';

const Item = ({ label, children }: { label: string; children: ReactNode }) => {
  return (
    <Stack gap={5}>
      <Text fw={500}>{label}</Text>
      <Box>{children}</Box>
    </Stack>
  );
};

export const MessageTemplateInfo = ({ value }: { value: MessageTemplate }) => {
  return (
    <Box className="flex-1">
      <Stack gap="lg">
        <Box>
          <Text fw={700} c="#ADB5BD" mb="xl">
            訊息內容設定
          </Text>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Flex direction="column" gap="md">
                <Item label="訊息分類">
                  <Text>
                    <MessageCategoryText value={value.messageCategory} />
                  </Text>
                </Item>
                <Item label="標題">
                  <Text>{value.title}</Text>
                </Item>
                <Item label="內文">
                  <Text>{value.summary}</Text>
                </Item>
                <Item label="圖片">
                  {value.thumbUrl ? (
                    <div>
                      <img
                        src={value.thumbUrl}
                        className="h-40 object-contain w-100 mx-auto"
                      />
                    </div>
                  ) : (
                    <Text>無上傳圖片</Text>
                  )}
                </Item>
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Stack>
                <ActionSettingDisplay
                  actionSettingType={value.actionSetting.type}
                />
                <TemplatePreview value={toMessageFormValue(value)} />
              </Stack>
            </Grid.Col>
          </Grid>
        </Box>

        <Box>
          <Text fw={700} c="#ADB5BD" mb="xl">
            發送設定
          </Text>
          <Grid gap="md">
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Stack gap="lg">
                <Item label="通知方式">
                  <Group>
                    <Text>{`發送推播通知:${value.notificationSettings.notification.push_enabled ? '啟用' : '未啟用'}`}</Text>
                  </Group>
                </Item>
                <Item label="發送對象（僅車麻吉通路）">
                  <MessageSendingTargetText
                    segment={value.segment}
                    segmentSnapshot={value.segmentSnapshot}
                    templateId={value.id}
                    state={value.state}
                  />
                </Item>
              </Stack>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Item label="發送時間">
                <Text>
                  {value.scheduleAt
                    ? format(value.scheduleAt, 'yyyy/MM/d hh:mm a')
                    : '未設定'}
                </Text>
              </Item>
            </Grid.Col>
          </Grid>
        </Box>
      </Stack>
    </Box>
  );
};

export default MessageTemplateInfo;
